/*
 *   File : add-banner.js
 *   Author : https://evoqins.com
 *   Description : Add banner modal
 *   Integrations : react-toastify
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// Custom components
import { CustomDatePicker, CustomFileUpload, CustomSelectBox, CustomTextInput, CustomTimePicker } from '../FormElements';
import { PrimaryButton, SecondaryButton, TextButton } from '../Buttons';
import { APIService, AWSService } from '../../Service';
import { Icon } from '../Icon';

// style 
import styles from "../../Style/Component/modal.module.scss";
import { Modal } from 'bootstrap';
import { format } from 'date-fns';
import moment from 'moment';

const TYPE = [
    {
        value: 1,
        label: 'IN-APP',
    },
    {
        value: 2,
        label: 'External'
    },
];

const ManageBanner = (props) => {

    const [image, setImage] = useState(null);
    const [imageError, setImageError] = useState("");
    const [success, setSuccess] = useState(false);
    const [selectedType, setSelectedType] = useState(TYPE[0]);
    const [selectedResource, setSelectedResource] = useState(props.resourceOptions[0]);
    const [selectedResourceError, setSelectedResourceError] = useState("");

    const [selectedData, setSelectedData] = useState(null);
    const [selectedDataError, setSelectedDataError] = useState("");

    const [externalUrl, setExternalUrl] = useState("");
    const [externalUrlError, setExternalUrlError] = useState("");
    const [editData, setEditData] = useState(props.editData);
    const [loading, setLoading] = useState(true);
    const [uploadLoader, setUploadLoader] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const [errorUpdate, setErrorUpdate] = useState(false);


    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDateError, setSelectedDateError] = useState("");
    const [dateToggle, setDateToggle] = useState(false);

    const [showTimePicker, setShowTimePicker] = useState(false);
    const [selectedTime, setSelectedTime] = useState(null);
    const [timeError, setTimeError] = useState("");

    useEffect(() => {
        if (dateToggle === true) {
            const date_modal = new Modal(document.getElementById('date-modal'));
            date_modal.show();
        }
    }, [dateToggle]);

    useEffect(() => {
        setEditData(props.editData);
    }, [props.editData]);

    useEffect(() => {
        if (editData.length !== 0) {
            setImage(editData.data.image);
            setSelectedType({ value: editData.data.type_id, label: editData.data.type });
            if (editData.data.type_id === 1) {
                setSelectedResource({ value: editData.data.content_id, label: editData.data.content_name })
                setSelectedData({ value: editData.data.data_id, label: editData.data.data_name });
            } else {
                setExternalUrl(editData.data.url)
            }

            if (editData.data.scheduled_date) {
                setSelectedDate(editData.data.scheduled_date);

                const updated_time = moment(editData.data.scheduled_time, 'h:mm a');
                setSelectedTime(updated_time);
            }
        }

    }, [editData]);

    useEffect(() => {
        setImageError("");
    }, [image]);

    useEffect(() => {
        setSelectedResourceError("");
    }, [selectedResource]);

    useEffect(() => {
        setSelectedDataError("");
    }, [selectedData]);
    useEffect(() => {
        setExternalUrlError("");
    }, [externalUrl]);

    useEffect(() => {
        setSelectedDateError("");
    }, [selectedDate]);

    // handle upload scheduled image
    const _uploadedImage = (url) => {
        setUploadLoader(true);
        _getPresignedUrl(url);
    };

    // handle close Modal 
    const _handleCloseModal = () => {
        var button = document.getElementById("add-offer-modal-close");
        button.click();
        setImageError("");
        setExternalUrl("");
        setImage(null);
        setSelectedResource(null);
        setSelectedData(null);
        setSuccess(false);
        props.handleClose();
    };

    // handle success
    const _handleSuccess = () => {
        var button = document.getElementById("add-offer-modal-close");
        button.click();
        setImageError("");
        setExternalUrl("");
        setImage(null);
        setSelectedResource(null);
        setSelectedData(null);
        setSuccess(false);
        props.success();
    };

    // handle select resource type
    const _handleSelectedResourceType = (value) => {
        setSelectedResource(value);

        setSelectedData(null);
    };

    // date toggle show an hide
    const _handleDateToggle = () => {
        setDateToggle(!dateToggle);
    };


    // handle select start date
    const _handleSelectedDate = (day) => {
        setSelectedDate(day);
        setDateToggle(false);
        _handleCloseStartDateModal();
    };

    // handle show time picker 
    const _handleShowTimePicker = () => {
        setShowTimePicker(!showTimePicker)
    }

    // handle time change 
    const _handleTimeChange = (value) => {
        setSelectedTime(value);
    };


    // handle close start date modal 
    const _handleCloseStartDateModal = () => {
        var button = document.getElementById("date-modal-close");
        button.click();
        setDateToggle(false);
    };

    // handle submit offer
    const _handleSubmit = () => {

        let is_valid = true;

        if (image === null) {
            setImageError("Image is required");
            is_valid = false;
        }

        if (selectedType?.value === 1 && (selectedResource?.label === "News" || selectedResource?.label === "Course")) {
            if (selectedData === null) {
                setSelectedDataError("Select data");
                is_valid = false;
            }
        }

        // const httpsRegex = /^www./;
        const httpsRegex = /^(https?:\/\/|www\.)[\w-]+(\.[\w-]+)+([/?#].*)?$/;

        if (selectedType?.label !== "IN-APP" && externalUrl.length === 0 || (externalUrl.length > 0 && !httpsRegex.test(externalUrl))) {
            setExternalUrlError("Please provide valid url");

            is_valid = false;

        }


        if (props.bannerType === 4) {
            if (selectedDate === null) {
                setSelectedDateError("Please provide schedule date");
                is_valid = false;
            }

            if (selectedTime === null) {
                setTimeError("Time is required");
                is_valid = false;
            }
        }


        setErrorUpdate(prev => !prev);

        if (is_valid === true) {
            setLoading(false);

            if (editData.type === "edit") {
                _updateBanner();
            } else {
                _createBanner();
            }
        }
    };

    // handle delete banner 
    const _handleDeleteBanner = (id) => {
        props.handleDelete(id);
        _handleCloseModal();
    }

    // get presigned url
    async function _getPresignedUrl(file) {
        let is_post = true;
        let url = 'general/file-upload';
        let data = {
            "file": file.name,
            "is_public": true
        };
        try {
            let response = await APIService(is_post, url, data);
            if (response.status_code == 200) {

                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {
                        setImage(response.data.view_info);
                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) {
        }
        setUploadLoader(false);
    };

    // API - Create banner
    const _createBanner = () => {
        let is_post = true;
        let url = 'CA/banner/create';
        let data = {
            "image": image,
            "type": selectedType.value,
            "content_id": selectedType.value === 1 ? selectedResource.value : null,
            "data_id": selectedType.value === 1 && (selectedResource?.label === "News" || selectedResource?.label === "Course") ? selectedData.value : null,
            "external_url": externalUrl.length !== 0 ? externalUrl : null,
            "scheduled_date": props.bannerType === 4 ? format(selectedDate, 'yyyy-MM-dd') : null,
            "scheduled_time": props.bannerType === 4 ? selectedTime.format('HH:mm:ss') : null,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setSuccess(true);
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
            setLoading(true);
        });
    };

    // API - Edit banner
    const _updateBanner = () => {
        let is_post = true;
        let url = 'CA/banner/edit';
        let data = {
            "banner_id": editData.data.banner_id,
            "image": image,
            "type": selectedType.value,
            "content_id": selectedType.value === 1 ? selectedResource.value : null,
            "data_id": selectedType.value === 1 && (selectedResource?.label === "News" || selectedResource?.label === "Course") ? selectedData.value : null,
            "url": externalUrl.length !== 0 ? externalUrl : null,
            "scheduled_date": props.bannerType === 4 ? format(selectedDate, 'yyyy-MM-dd') : null,
            "scheduled_time": props.bannerType === 4 ? selectedTime.format('HH:mm:ss') : null,
        };

        APIService(is_post, url, data).then((response) => {
            if (response.status_code === 200) {
                setSuccess(true);

            } else {
            }
            setLoading(true);
        });
    };

    return (
        <div className="modal fade" id="add-banner-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="addBannerModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content e-border-radius-12 w-480px mx-auto px-4 ">
                    <img src={require("../../Assets/Image/CountryAdmin/close-icon.svg").default}
                        id='add-offer-modal-close'
                        className='d-none'
                        alt='close'
                        data-bs-dismiss="modal" />
                    {!success ?
                        <>
                            <div className="modal-header px-0 pt-4 pb-2 border-0">
                                <h4 className="mb-0 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px">
                                    {editData.type === "edit" ? 'Edit banner' : 'Add new banner'}
                                </h4>
                                <Icon icon="close-icon"
                                    className='cursor-pointer'
                                    size="24px"
                                    onPress={_handleCloseModal} />
                            </div>
                            <div className={`modal-body px-0 pe-1 pt-0 pb-2 e-modal-body-wrapper`}>
                                <div className={`${styles.e_modal_body_wrapper}  `}>
                                    <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                        Create a new banner for any resource type.
                                    </p>
                                    <div className="pt-2">

                                        {/* upload thumbnail */}
                                        <CustomFileUpload label="Add banner image"
                                            placeholder="Drop your image here"
                                            file={image}
                                            fileType={["JPG", "PNG", "JPEG"]}
                                            loader={uploadLoader}
                                            require
                                            resolution="328px * 138px"
                                            requiredWidth={328}
                                            requiredHeight={138}
                                            error={imageError}
                                            errorUpdate={errorUpdate}
                                            handleChange={_uploadedImage} />

                                        {/* change thumbnail button */}
                                        {image !== null &&
                                            <div className='margin-neg-16px-top'>
                                                <TextButton name="Change Image"
                                                    onPress={() => setImage(null)} />
                                            </div>
                                        }

                                        {/* Type select */}
                                        <CustomSelectBox label="Type"
                                            value={selectedType}
                                            options={TYPE}
                                            className="e-modal-select"
                                            isSearchable={false}
                                            selectChange={(id) => { setSelectedType(id); }}
                                        />

                                        {selectedType.label === "IN-APP" ?
                                            <>
                                                {/* select resource type  */}
                                                <CustomSelectBox label="Resource type"
                                                    value={selectedResource}
                                                    options={props.resourceOptions}
                                                    error={selectedResourceError}
                                                    menuPortalTarget={document.body}
                                                    className="e-modal-select"
                                                    isSearchable={false}
                                                    selectChange={(id) => _handleSelectedResourceType(id)} />

                                                <>
                                                    {/* Course select */}
                                                    {selectedResource?.label === "Course" ?
                                                        <CustomSelectBox label="Course"
                                                            value={selectedData}
                                                            options={props.courseList}
                                                            error={selectedDataError}
                                                            className="e-modal-select"
                                                            menuIsOpen={menuOpen}
                                                            menuPortalTarget={document.body}
                                                            isSearchable={true}
                                                            onMenuOpen={() => setMenuOpen(true)}
                                                            onMenuClose={() => setMenuOpen(false)}
                                                            selectChange={(id) => { setSelectedData(id); }}
                                                        />
                                                        :
                                                        // News select
                                                        selectedResource?.label === "News" ?
                                                            <CustomSelectBox label="News"
                                                                value={selectedData}
                                                                options={props.newsOptions}
                                                                error={selectedDataError}
                                                                className="e-modal-select"
                                                                menuIsOpen={menuOpen}
                                                                menuPortalTarget={document.body}
                                                                isSearchable={true}
                                                                onMenuOpen={() => setMenuOpen(true)}
                                                                onMenuClose={() => setMenuOpen(false)}
                                                                selectChange={(id) => { setSelectedData(id); }} />
                                                            :
                                                            // Competition select
                                                            // <CustomSelectBox label="Competition"
                                                            //     value={selectedData}
                                                            //     options={props.competitionOptions}
                                                            //     error={selectedDataError}
                                                            //     className="e-modal-select"
                                                            //     menuIsOpen={menuOpen}
                                                            //     menuPortalTarget={document.body}
                                                            //     isSearchable={true}
                                                            //     onMenuOpen={() => setMenuOpen(true)}
                                                            //     onMenuClose={() => setMenuOpen(false)}
                                                            //     selectChange={(id) => { setSelectedData(id); }} />
                                                            null
                                                    }
                                                </>
                                            </>
                                            :

                                            // External url
                                            <div >
                                                <CustomTextInput label="External url"
                                                    placeholder="Url"
                                                    type="text"
                                                    value={externalUrl}
                                                    error={externalUrlError}
                                                    className="w-100"
                                                    labelStyle="pb-1 e-font-weight-400 e-text-raisin-black"
                                                    handleChange={(e) => setExternalUrl(e)} />
                                            </div>
                                        }


                                        {props.bannerType === 4 &&
                                            <div>
                                                <div>
                                                    <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                                        Schedule date<span className='e-text-lust'>*</span>
                                                    </p>
                                                    <div className='pt-2'>
                                                        <div className='position-relative h-60px'>
                                                            <div className={`${dateToggle ? 'e-border-1px-indigo' : 'e-border-1px-platinum-light'} d-flex justify-content-between e-border-radius-6 padding-14px-tb px-3 cursor-pointer`}
                                                                onClick={_handleDateToggle}>

                                                                {selectedDate !== null ?
                                                                    <p className='mb-0 e-text-raisin-black e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                                        {format(selectedDate, 'PP')}
                                                                    </p>
                                                                    :
                                                                    <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-16px'>
                                                                        Choose date
                                                                    </p>
                                                                }

                                                                {selectedDate !== null ?
                                                                    <div onClick={(e) => e.stopPropagation()}>
                                                                        <Icon icon="close-icon"
                                                                            className='position-absolute top-14px right-14px cursor-pointer'
                                                                            size={18}
                                                                            onPress={() => setSelectedDate(null)} />
                                                                    </div>
                                                                    :
                                                                    <img src={require("../../Assets/Image/CountryAdmin/Notification/calendar-icon.svg").default}
                                                                        draggable={false}
                                                                        alt='calender-icon' />
                                                                }
                                                            </div>

                                                            {/* error message */}
                                                            <p className='mb-0 e-error-message e-alt-font-noto-sans e-font-12 line-height-12px padding-2-top'>
                                                                {selectedDateError}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <CustomTimePicker label="Set time"
                                                    showSecond={false}
                                                    placeholder='Choose a time'
                                                    value={selectedTime}
                                                    open={showTimePicker}
                                                    error={timeError}
                                                    handleClose={_handleShowTimePicker}
                                                    handleOpen={_handleShowTimePicker}
                                                    handleChange={_handleTimeChange} />
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>

                            <div className='modal-footer border-0 pt-2 pb-4 px-0'>
                                <div className={`row row-cols-2 w-100`}>
                                    {editData.type === "edit" ?
                                        <div className='col m-0 ps-0 '>
                                            <SecondaryButton name="Delete"
                                                className="w-100"
                                                onPress={() => _handleDeleteBanner(editData.data.banner_id)} />
                                        </div>
                                        :
                                        <div className='col m-0 ps-0'>
                                            <SecondaryButton name="Cancel"
                                                className="w-100"
                                                onPress={_handleCloseModal} />
                                        </div>
                                    }
                                    <div className='col pe-0 m-0'>
                                        <PrimaryButton name={editData.type === "edit" ? "Update" : "Save banner"}
                                            className="w-100"
                                            status={!loading}
                                            onPress={_handleSubmit} />
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="modal-header px-0 pt-4 pb-2 border-0 align-items-start">
                                <img src={require("../../Assets/Image/CountryAdmin/success-icon.svg").default}
                                    draggable={false}
                                    alt='icon' />
                                <Icon icon="close-icon"
                                    className='cursor-pointer'
                                    size="24px"
                                    onPress={_handleSuccess} />
                                <button type="button" className="btn-close shadow-none d-none" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body px-0 pb-2 pt-2">
                                <h6 className='mb-2 e-primary-font-playfair e-font-18 e-text-raisin-black e-font-weight-500 line-height-28px'>
                                    {editData.type === "edit" ? 'Banner updated successfully' : 'Banner added successfully'}
                                </h6>
                                <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-14 e-font-weight-400 line-height-20px'>
                                    Banner uploaded successfully! Your changes are now live. Feel free to review and make any updates as needed.
                                </p>

                            </div>

                            <div className='modal-footer border-0 px-0 pb-4 pt-2 '>
                                <PrimaryButton name="Ok"
                                    className="w-100"
                                    onPress={_handleSuccess} />
                            </div>
                        </>
                    }

                </div>
            </div>


            {dateToggle &&
                <div className="modal fade" id="date-modal" data-bs-backdrop="false" tabIndex="-1" aria-labelledby="dateModalLabel" aria-hidden="true"
                    onClick={_handleCloseStartDateModal}>
                    <div className="modal-dialog modal-dialog-centered e-border-radius-24 ">
                        <button id='date-modal-close'
                            className='d-none '
                            data-bs-dismiss="modal" />
                        <div className="modal-content w-358px  mx-auto border-0 bg-transparent e-date-modal-box-shadow ">
                            <CustomDatePicker type="modal"
                                minDate={new Date()}
                                selected={selectedDate}
                                onSelect={_handleSelectedDate} />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default memo(ManageBanner);